import { createFileRoute, redirect } from '@tanstack/react-router';

import {
  teamChatRedirectSearch,
  teamChatSearchSchema,
  type TeamChatSearch,
} from '@/pages/messages/chat-search';

/**
 * `/teams/:slug/chat` is not a page any more (W5-B · One Chat): a team's chat
 * is Chat filtered to the team — `/my/messages?team=<slug>` — on desktop and
 * iPhone alike, so the same channel behaves the same from any entry.  Old
 * links keep their target: `?topic=` (+ `&thread=`) opens that channel (and
 * thread), `?dm=` that direct message.
 */
export const Route = createFileRoute('/teams/$teamSlug/chat')({
  // Lenient: a malformed id in an old link still lands in the team's Chat.
  validateSearch: (raw: Record<string, unknown>): TeamChatSearch => {
    const parsed = teamChatSearchSchema.safeParse(raw);
    return parsed.success ? parsed.data : {};
  },
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/my/messages',
      search: teamChatRedirectSearch(params.teamSlug, search),
      replace: true,
    });
  },
});
